<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'colorPicker',
})
</script>
<template>
  <a-popconfirm @ok="submit" @cancel="clear" :icon="false">
    <template #title>
      <div >
       <div class="color-container">
        <div class="color-box" v-for="(item,i) in colors" :key="i" :style="{background:getColor(item)}"  @click="checkColor(item)">
        </div>
        <div class="color-box text-red   align-center justify-center" @click="clear">x</div>
      </div>
        <a-slider  v-if="type!='hex'" v-model:value="defOpacity" :min="0x00" :max="0x255" />
        <a-input placeholder="请输入颜色值"  @change="textChange" v-model:value="def" :allowClear="true"></a-input>
      </div>
    </template>
    <div class="selected-color flex align-center justify-center" :style="{background:def,width:size+'px',height:size+'px'}">
      <span class="text-gray" v-if="value==''">无色</span>
    </div>
  </a-popconfirm>

</template>
<script setup  name="colorPicker" lang="ts">
import {ref,defineProps,defineEmits,onMounted,watch, watchEffect} from 'vue'
   const props=defineProps({
      value:{type:String},
      size:{type:Number,default:100},
      type:{type:String,default:'rgb'} //rgb|hex
  })

  const emits= defineEmits(['update:value'])
  const defOpacity=ref<Number>(0x255)
  const defColor=ref<number>(0x000000)
  const def=ref<String>('')
  const colors=ref<Array>([])
  const getColor=(item:Number)=>{
     return '#'+ item.toString(16).padStart(6,'0')
  }
  onMounted(()=>{
    def.value=props.value
    var ls=[]
     for(var r=0x2a;r<0xff;r+=0x2a)
     {
      for(var g=0x2a;g<0xff;g+=0x2a)
      {
        for(var b=0x2a;b<0xff;b+=0x2a)
        {
          ls.push(r*0xffff+g*0xff+b)
        }
      }
     }
     for(var b=0x00000;b<=0xffffff;b+=0x111111){
      ls.push(b)
     }

      colors.value=ls;
  })


  //把#fff|#ffffff|rgb(255,255,255)|rgba(255,255,255,255) 字符串转成rgba数组
  const formartStringToRgba=(hex)=>{
    hex=hex.replace(/\s+/g, ' ').trim()
    try{
      if(hex.startsWith("#")){
        hex=hex.replace('#','')
        if(hex.length==3){
            var r=hex.substring(0,1)
            var g=hex.substring(1,1)
            var b=hex.substring(2,1)
            return [parseInt(r+r,16),parseInt(g+g,16),parseInt(b+b,16),0x255]
        }else if(hex.length==6||hex.length==8){
            var r=hex.substring(0,2)
            var g=hex.substring(2,2)
            var b=hex.substring(4,2)
            var o= [parseInt(r,16),parseInt(g,16),parseInt(b,16),0x255]
            if(hex.length>6){
              var a=hex.substring(6,2)
              o.push(parseInt(a,16))
            }
            return o
        }else{
            throw "parseRGBErr"
        }
      }else if(hex.startsWith('rgb')){
        hex=hex.replace('rgba','').replace('rgb','').replace('(','').replace(')','')
        var rs=hex.split(',')
        var rgba=rs.map(e=>parseInt(e,16))
        if(rgba.length==3){rgba.push(0x255)}
        if(rgba.length!=3||rgba.length!=4){
          throw 'parseRGBErr'
        }
        return rgba
      }else{
        throw 'parseRGBErr'
      }
     }catch{
      return [255,255,255,255]
     }
  }

  const checkColor=(e)=>{
      defColor.value=e
      if(props.type=='hex'){
        def.value=  '#'+ e.toString(16).padStart(6,'0')
      }else{
        var rgb=e.toString(16).padStart(6,'0')
        var r= parseInt(rgb.substring(0,2),16)
        var g= parseInt(rgb.substring(2,2),16)
        var b= parseInt(rgb.substring(4,2),16)
        def.value='rgba('+r+','+g+','+b+','+defOpacity.value+')'
      }
      emits('update:value',def.value)
  }
  const sliderChange=(e)=>{
      defOpacity.value=e
     if(defColor.value){
       checkColor(defColor.value)
     }
  }
  const submit=()=>{
    emits('update:value',def.value)
  }
  const clear=()=>{
    def.value=""
    emits('update:value',"")
  }
  const textChange=(e)=>{
      if(e==''){
          clear()
      }
  }
</script>
<style>
  .color-container{width:280px;}
  .color-box{width:15px;height: 15px;margin:1px;padding:0;display:inline-flex;cursor: pointer;box-shadow: #888 0 0 1px;}
  .selected-color{border-radius:5px;border: 1px solid #dfdfdf;cursor: pointer;text-wrap: wrap;padding:5px;display: inline-block;}
  .color-box:hover{box-shadow: #333 0 0 5px;transform: scale(1.5);}
</style>
